var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReleaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_8961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15.64C28.1619 15.64 26.3648 15.9613 24.6573 16.5949L25.1027 17.7949C26.67 17.2139 28.3285 16.9176 30 16.92C37.7639 16.92 44.08 23.2362 44.08 31C44.08 38.7639 37.7639 45.08 30 45.08C22.2362 45.08 15.92 38.7639 15.92 31C15.9212 28.9255 16.3808 26.8769 17.2659 25.0007C18.1511 23.1245 19.4398 21.4671 21.04 20.1469V24.6H22.32V18.2H15.92V19.48H19.8407C18.2063 20.9215 16.8974 22.6942 16.0008 24.6804C15.1041 26.6666 14.6403 28.8208 14.64 31C14.64 39.4691 21.5309 46.36 30 46.36C38.4691 46.36 45.36 39.4691 45.36 31C45.36 22.5309 38.4691 15.64 30 15.64Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.16 36.12H24.88V37.4H35.12V36.12H33.84V33.935L30.905 31L33.84 28.0649V25.88H35.12V24.6H24.88V25.88H26.16V28.0649L29.095 31L26.16 33.935V36.12ZM27.44 27.535V25.88H32.56V27.535L30 30.095L27.44 27.535ZM30 31.9049L32.56 34.4649V36.12H27.44V34.4649L30 31.9049ZM26.16 39.96H27.44V41.24H26.16V39.96ZM29.36 39.96H30.64V41.24H29.36V39.96ZM32.56 39.96H33.84V41.24H32.56V39.96Z",
    fill: "#00ADEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_8961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseIcon);
export default __webpack_public_path__ + "static/media/releaseIcon.e1dccd7dc636f341949caa1c4f8bef42.svg";
export { ForwardRef as ReactComponent };